import { render, staticRenderFns } from "./SendPoints.vue?vue&type=template&id=38baad32"
import script from "./SendPoints.vue?vue&type=script&lang=js"
export * from "./SendPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports